"use strict";

exports.__esModule = true;
exports.onRouteUpdate = void 0;
var ackeeTracker = _interopRequireWildcard(require("ackee-tracker"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Hold the tracker instance. Persists after the client is hydrated,
 * so is destroyed when any page is re-fetched from the server.
 */
var trackerInstance;

/**
 * Record a page visit when it is visited.
 *
 * @param {*} _ - unused object with parameters `location` and `prevLocation`.
 * @param {*} pluginOptions - contains all options as defined by the config.
 */
var onRouteUpdate = function onRouteUpdate(_, _ref) {
  var domainId = _ref.domainId,
    server = _ref.server,
    ignoreLocalhost = _ref.ignoreLocalhost,
    ignoreOwnVisits = _ref.ignoreOwnVisits,
    detailed = _ref.detailed;
  /**
   * If there is no tracker instance, instantiate one with the plugin options.
   */
  if (trackerInstance == null) {
    trackerInstance = ackeeTracker.create(server, {
      ignoreLocalhost: ignoreLocalhost,
      ignoreOwnVisits: ignoreOwnVisits,
      detailed: detailed
    });
  }

  /**
   * Record the visit to this route.
   */
  trackerInstance.record(domainId);
};
exports.onRouteUpdate = onRouteUpdate;